var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.31084 4.65149L7.99999 2.53051L8.68914 4.65149C9.01044 5.64034 9.93193 6.30984 10.9717 6.30984H13.2018L11.3976 7.62068C10.5564 8.23183 10.2044 9.31511 10.5257 10.304L11.2149 12.4249L9.41068 11.1141C8.56951 10.503 7.43048 10.503 6.58931 11.1141L4.7851 12.4249L5.47424 10.304C5.79554 9.31511 5.44356 8.23183 4.60239 7.62068L2.79818 6.30984H5.02831C6.06805 6.30984 6.98955 5.64034 7.31084 4.65149ZM7.04893 0.927065C7.34829 0.00575447 8.6517 0.00575495 8.95105 0.927066L10.0206 4.21886C10.1545 4.63089 10.5384 4.90985 10.9717 4.90985H14.4329C15.4016 4.90985 15.8044 6.14946 15.0207 6.71886L12.2205 8.7533C11.87 9.00795 11.7233 9.45932 11.8572 9.87134L12.9268 13.1631C13.2261 14.0844 12.1717 14.8506 11.3879 14.2812L8.58778 12.2467C8.23729 11.9921 7.76269 11.9921 7.41221 12.2467L4.61204 14.2812C3.82832 14.8506 2.77384 14.0844 3.0732 13.1631L4.14276 9.87134C4.27664 9.45932 4.12998 9.00795 3.77949 8.7533L0.979324 6.71886C0.195611 6.14946 0.598387 4.90985 1.56711 4.90985H5.02831C5.46154 4.90985 5.84549 4.63089 5.97937 4.21886L7.04893 0.927065Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/starEmpty.09b3d5b01ebee0bd48c16d978f3a66f0.svg";
export { ForwardRef as ReactComponent };